import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  display: flex;
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    padding: ${size[24]};
  }
`

export const wrapper = (theme: Theme) => css`
  max-width: ${width.container.large};
  width: 100%;
  padding: ${size[24]};
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${theme.palette.background.accent};

  ${breakpoint.up('smMd')} {
    margin: 0 auto;
    max-width: ${width.container.large};
    padding: ${size[40]};
  }
`

export const preview = css`
  ${breakpoint.up('smMd')} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${size[48]};
  }
`

export const text = css`
  margin-top: ${size[32]};

  ${breakpoint.up('smMd')} {
    margin-top: ${size[8]};
  }
`

export const content = css`
  width: 100%;
`

export const title = css`
  margin-bottom: ${size[12]};
`

export const subtitle = css`
  margin: ${size[32]} 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    margin-top: ${size[40]};
  }
`

export const steps = css`
  display: flex;
  flex-direction: column;
  gap: ${size[12]};
`

export const step = (theme: Theme) => css`
  display: flex;
  align-items: flex-start;
  gap: ${size[8]};

  ${breakpoint.up('smMd')} {
    color: ${theme.palette.tertiary.upperMediumContrast};
  }
`

export const stepLabel = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-size: ${fontSize.md};
  font-weight: 500;
  width: fit-content;
  white-space: nowrap;
`

export const performance = css`
  display: flex;
  flex-direction: column;
  gap: ${size[32]};

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${size[32]};
  }
`

export const performanceItem = css`
  text-align: center;

  ${breakpoint.up('smMd')} {
    h3 {
      font-weight: 400;
    }
  }
`

export const headline = (theme: Theme) => css`
  margin-bottom: ${size[8]};
  color: ${theme.palette.primary.mainContrast};
  font-size: ${fontSize.xxl};
`

export const cta = css`
  margin-top: ${size[48]};
  display: flex;
  flex-direction: column;
  gap: ${size[16]};

  a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    justify-content: center;
    gap: ${size[24]};
  }
`
